


















































































































import {Component, Vue, Config, BasePage} from '@/common';
import orderEdit from './components/orderEdit.vue';
import orderItems from './components/orderItems.vue';
import orderList from './components/ordertrack.vue';
import config from '@/config'
import {TwTable} from '@/components';

@Component({
	components: {
		orderEdit,
		orderItems,
		orderList,
	},
})
export default class Order extends BasePage {
	get table(): TwTable {
		return this.$refs['table'] as TwTable;
	}

	rowGuid = '';
	showEdit = false;
	columns = [];
	parentKey = '';
	CONTRINFO = [];
	TOADRESSINFO = [];
	CARNAMEINFO = [];
	SHCARNAMEINFO = [];
	showItems = false;
	showTrack = false;
	showPrint = false;
	printSrc = '';

	fileKey = '';

	searchMode = {
		Y_NO: '',
		TH_DATE_FROM: null,
		TH_DATE_TO: null,
		ORDER_TYPE: '',
		TO_DZ:""
	};

	get exData() {
		return {
			Y_NO: this.searchMode.Y_NO,
			TH_DATE_FROM: this.searchMode.TH_DATE_FROM,
			TH_DATE_TO: this.searchMode.TH_DATE_TO,
			ORDER_TYPE: this.searchMode.ORDER_TYPE,
			TO_DZ:this.searchMode.TO_DZ
		}
	}

	ok() {
		this.table.reload();
		this.fileKey = '';
	}

	add() {
		this.rowGuid = '';
		this.showEdit = true;
	}

	refresh() {
		this.table.load({...this.searchMode});
		this.fileKey = '';
	}

	startRows() {
		this.$confirm('执行之后订单将不能修改, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning',
		})
			.then(() => {
				this.$http
					.post('Biz/Order/Start', {
						GUID: this.table.getSelections().map((item) => item.GUID),
					})
					.then((res) => {
						if (res.data.status === 0) {
							this.$message.success('执行成功');
							this.fileKey = '';
							this.table.reload();
						} else {
							this.$message.warning(res.data.msg || '操作失败');
						}
					});
			})
			.catch(() => {
			});
	}

	sendRows() {
		this.$confirm('执行之后订单将传给跨越系统, 是否确认?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning',
		})
			.then(() => {
				this.$http
					.post('Biz/Order/Send', {
						GUID: this.table.getSelections().map((item) => item.GUID),
					})
					.then((res) => {
						if (res.data.status === 0) {
							this.$message.success('执行成功');
							this.fileKey = '';
							this.table.reload();
						} else {
							this.$message.warning(res.data.msg || '操作失败');
						}
					});
			})
			.catch(() => {
			});
	}

	sendLQRows() {
		this.$confirm('执行之后订单将传给蓝桥系统, 是否确认?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning',
		})
			.then(() => {
				this.$http
					.post('Biz/Order/SendLQ', {
						GUID: this.table.getSelections().map((item) => item.GUID),
					})
					.then((res) => {
						if (res.data.status === 0) {
							this.$message.success('执行成功');
							this.fileKey = '';
							this.table.reload();
						} else {
							this.$message.warning(res.data.msg || '操作失败');
						}
					});
			})
			.catch(() => {
			});
	}

	updateLQRows() {
		this.$confirm('执行之后订单将更新到蓝桥系统, 是否确认?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning',
		})
			.then(() => {
				this.$http
					.post('Biz/Order/UpdateLQ', {
						GUID: this.table.getSelections().map((item) => item.GUID),
					})
					.then((res) => {
						if (res.data.status === 0) {
							this.$message.success('执行成功');
							this.fileKey = '';
							this.table.reload();
						} else {
							this.$message.warning(res.data.msg || '操作失败');
						}
					});
			})
			.catch(() => {
			});
	}
	

	closeRows() {
		this.$confirm('执行之后订单将关闭, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning',
		})
			.then(() => {
				this.$http
					.post('Biz/Order/CloseOrder', {
						GUID: this.table.getSelections().map((item) => item.GUID),
					})
					.then((res) => {
						if (res.data.status === 0) {
							this.$message.success('执行成功');
							this.fileKey = '';
							this.table.reload();
						} else {
							this.$message.warning(res.data.msg || '操作失败');
						}
					});
			})
			.catch(() => {
			});
	}

	dbClick(row) {
		this.showEdit = true;
		this.rowGuid = row.GUID;
	}

	rowClick(row) {
		this.fileKey = row.Y_NO;
	}

	print() {
		let rows = this.table.getSelections();
		if (!rows.length) {
			this.$message.warning('请选中要打印标签的数据');
			return;
		}
		this.showPrint = true;

		let billnos = rows.map(item => item.Y_NO).join(',');

		this.printSrc = config.baseUrl + '/Biz/Order/Index?billnos=' + billnos
	}

	deleteRows() {
		this.$confirm('此操作将永久删除该数据以及明细, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning',
		})
			.then(() => {
				this.$http
					.post('Biz/Order/Delete', {
						GUID: this.table.getSelections().map((item) => item.GUID),
					})
					.then((res) => {
						if (res.data.status === 0) {
							this.$message.success('删除成功');
							this.fileKey = '';
							this.table.reload();
						} else {
							this.$message.warning(res.data.msg || '操作失败');
						}
					});
			})
			.catch(() => {
			});
	}

	renderItem(props) {
		return (
			<div
				onClick={() => {
					this.parentKey = props.row.GUID;
					this.showItems = true;
				}}
				style="color:blue;text-decoration:underline;cursor: pointer;"
			>
				{props.row.QTY}
			</div>
		);
	}

	renderList(props) {
		if (
			props.row.ORDER_TYPE === '待分配' ||
			props.row.ORDER_TYPE === '已分配'
		) {
			return <div>{props.row.CONTR_NO}</div>;
		} else {
			return (
				<div
					onClick={() => {
						this.parentKey = props.row.Y_NO;
						this.showTrack = true;
					}}
					style="color:blue;text-decoration:underline;cursor: pointer;"
				>
					{props.row.CONTR_NO}
				</div>
			);
		}
	}

	mounted() {
		this.buildColumn('002001', this.columns);
		this.loadContr();
	}

	loadContr() {
		this.$http.get('Biz/Order/GetContr').then((res) => {
			if (res.data.status === 0) {
				this.CONTRINFO.splice(0);
				this.CONTRINFO.push(...res.data.CONTRINFO);
			}
		});

		this.$http.get('Biz/Order/GetCarname').then((res) => {
			if (res.data.status === 0) {
				this.CARNAMEINFO.splice(0);
				this.CARNAMEINFO.push(...res.data.CARNAMEINFO);
			}
		});

		this.$http.get('Biz/Order/GetSHCarname').then((res) => {
			if (res.data.status === 0) {
				this.SHCARNAMEINFO.splice(0);
				this.SHCARNAMEINFO.push(...res.data.SHCARNAMEINFO);
			}
		});

		this.$http.get('Biz/Order/GetToAdress').then((res) => {
			if (res.data.status === 0) {
				this.TOADRESSINFO.splice(0);
				this.TOADRESSINFO.push(...res.data.TOADRESSINFO);
			}
		});
	}
}
